<template>
  <div class="loginpage">
    <div class="loginBox">
      <div class="login-content">
        <div class="login-left">
          <div v-if="$store.state.eduWebConfig.eduWebConfigInfo.realmName !=
            'https://qhjy.lanyunxinli.cn'
            ">
            <div class="title2" style="
                font-size: 38px;
                margin-top: 55px;
                text-align: center;
                padding-left: 0;
              ">
              {{ $store.state.eduWebConfig.eduWebConfigInfo.eduName }}
              <div style="font-size: 22px; margin-top: 10px">
                {{ $store.state.eduWebConfig.eduWebConfigInfo.webName }}
              </div>
            </div>

            <img v-if="$store.state.eduWebConfig.eduWebConfigInfo.isQingHai" width="300px"
              style="margin-left: 97px; margin-top: 20px" src="/static/images/ly_logo2.png" alt="" />
            <img v-else width="300px" style="margin-left: 97px" src="/static/images/ly_logo.png" alt="" />
            <!-- <div
              v-if="$store.state.eduWebConfig.eduWebConfigInfo.isQingHai"
              class="group"
            >
              伟一集团
            </div> -->
          </div>
          <div v-else class="qhTitle">
            青海省中小学师生<br />心理健康应用系统
          </div>
        </div>
        <div class="login-right">
          <div class="title3">用户登录 / Login</div>
          <div class="log-row">
            <div style="margin-bottom: 10px">
              <span class="title4">用户名</span>
              <span class="title5">/ Username</span>
            </div>
            <el-input class="input-style userName" v-model="userName" @keyup.enter.native="uiLogin" type="text"
              :value="userName" placeholder="请输入用户名" />
          </div>
          <div class="log-row">
            <div style="margin-bottom: 10px">
              <span class="title4">密码</span>
              <span class="title5">/ Password</span>
            </div>
            <el-input class="input-style userPwd" v-model="userPwd" @keyup.enter.native="uiLogin" type="password"
              :value="userPwd" placeholder="请输入密码" />
          </div>

          <div class="row1">
            <div style="margin-bottom: 10px">
              <span class="title4">身份选择</span>
              <span class="title5">/ Identity</span>
            </div>
              <el-select
                  v-model="selectedRoleGroups"
                  multiple
                  clearable
                  collapse-tags
                  placeholder="请选择登陆身份"
                >
                  <el-option
                    v-for="item in roleGroups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
          </div>
          <div class="log-row">
            <el-button class="input-style btn" type="primary" @click="uiLogin">登 录
            </el-button>
            <div style="
                margin-top: 20px;
                display: flex;
                justify-content: space-between;
              ">
              <!-- <span
                              class="forget_pwd"
                              @click="$router.push({ name: 'registeredNumber' })"
                              >学生注册</span
                            >-->
              <span class="forget_pwd" @click="$router.push({ name: 'answerRegister' })">校外人员答题</span>
              <!-- <span class="forget_pwd" @click="backApp">APP介绍</span> -->
              <span class="forget_pwd" @click="backPwd">忘记密码？</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-text">
        <p>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51010702042932" rel="noreferrer" target="_blank"><img
              style="height: 15px; margin-right: 6px; margin-bottom: -2px"
              src="/static/images/备案图标.png">川公网安备51010702042932</a>
        </p>
        <p>
          <a target="_bank" href="https://beian.miit.gov.cn">蜀ICP备20012822号-4</a>
        </p>
        <p v-if="!$store.state.eduWebConfig.eduWebConfigInfo.scaleAlias">
          <a href="http://www.bluerhyme.net/" target="_bank">四川蓝韵心理咨询服务有限公司</a>
        </p>

        <p v-if="$store.state.eduWebConfig.eduWebConfigInfo.isQingHai">
          <a href="http://www.bluerhyme.net/" target="_bank">青海伟一蓝韵心理咨询服务有限公司</a>
        </p>

        <!-- <p v-else>
          <a href="http://www.bluerhyme.net/" target="_bank">四川心海蓝韵信息科技有限公司</a>
        </p> -->
      </div>
      <!-- 中域永信证书 -->
      <!-- <a
        href="https://xyt.xcc.cn/getpcInfo?sn=1745707094486523904&language=CN&certType=8&url=*.lanyunxinli.cn"
        target="_blank"
        style="position: relative; display: inline-block; height: 38px"
      >
        <div
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
        ></div>
        <embed
          src="https://program.xinchacha.com/web/1745707094486523904=*.lanyunxinli.cn.svg"
          width="103"
          height="38"
          type="image/svg+xml"
          pluginspage="//www.adobe.com/svg/viewer/install/"
      /></a> -->
    </div>
    <el-dialog append-to-body title="选择服务学校" :visible.sync="selectSchoolDialog" width="750px">
      <el-form :model="schoolForm" :rules="rules" ref="schoolFormRef" label-width="100px" class="schoolForm">
        <el-form-item label="选择教育局" prop="educationId">
          <el-select filterable @change="eduChange" v-model="schoolForm.educationId" placeholder="请选择教育局">
            <el-option v-for="item in eduList" :key="item.educationId" :label="item.name"
              :value="item.educationId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择学校" prop="schoolId">
          <el-select v-model="schoolForm.schoolId" filterable placeholder="请选择学校">
            <el-option v-for="item in schoolList" :key="item.schoolId" :label="item.schoolName"
              :value="item.schoolId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectSchoolDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitSelectSchool">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import screenfull from "screenfull"; //引入screenfull
export default {
  name: "login",
  data() {
    return {
      userName: "",
      isLogn: false,
      userPwd: "",
      remenber: false,
      selectSchoolDialog: false,
      eduList: [],
      schoolList: [],
      currentSchoolInfo: {},
      currentEduInfo: {},
      schoolForm: {
        educationId: "",
        schoolId: "",
      },
      rules: {
        educationId: [
          { required: true, message: "请选择教育局", trigger: "change" },
        ],
        schoolId: [
          { required: true, message: "请选择学校", trigger: "change" },
        ],
      },
      selectedRoleGroups: [1], // 已选中角色组
      roleGroups: [
        {
          label: "学生",
          value: 1,
        },
        {
          label: "家长",
          value: 2,
        },
        {
          label: "心理老师",
          value: 3,
        },
        {
          label: "教职工",
          value: 4,
        },
        // {
        //   label: "年级主任",
        //   value: 5,
        // },
        // {
        //   label: "教职工",
        //   value: 6,
        // },
        // {
        //   label: "班主任",
        //   value: 7,
        // },
        {
          label: "校级管理员",
          value: 8,
        },
        {
          label: "区级管理员",
          value: 9,
        },
        // {
        //   label: "教育厅",
        //   value: 10,
        // },
      ],
    };
  },
  methods: {
    // 获取教育局列表
    getEduList() {
      this.$request
        .get("/educationadmin/educationInfo/getAllEducation", {})
        .then((res) => {
          if (res && res.length) {
            this.eduList = res;
          }
        });
    },
    // 通过教育局编号获取学校列表
    getSchoolList() {
      this.$request
        .get("/educationadmin/schoolInfo/getSchoolOnEducation", {
          params: {
            educationid: this.schoolForm.educationId,
          },
        })
        .then((res) => {
          if (res && res.length) {
            this.schoolList = res;
          }
        });
    },

    // 教育局切换
    eduChange() {
      this.schoolForm.schoolId = "";
      this.getSchoolList(); // 获取学校列表
    },
    // 确认学校选择
    submitSelectSchool() {
      this.$refs.schoolFormRef.validate((volid) => {
        if (volid) {
          this.currentSchoolInfo = this.schoolList.find(
            (item) => item.schoolId == this.schoolForm.schoolId
          );
          // 更新2.0 版本token
          this.$request
            .get("/educationadmin/toSchoolPsychoTeacher", {
              params: {
                educationId: this.schoolForm.educationId,
                schoolId: this.schoolForm.schoolId,
                schoolName: this.currentSchoolInfo.schoolName,
                isordinary: this.currentSchoolInfo.isordinary,
              },
            })
            .then((res) => {
              if (res && res.token) {
                window.sessionStorage.setItem("LyToken", res.token);
              }
            })
            .catch(() => { });
        }
        // 更新1.0版本token
        let self = this;
        LYCom.AsynCallBiz(
          (e) => {
            if (e.err) {
            } else {
              if (e.rtnObj) {
                //设置token信息
                self.$store.commit("SET_TOKEN", e.rtnObj.token_id);
                self.$router.push("/schoolHome");
              } else {
                self.$message.error("进入学校错误！");
              }
            }
          },
          "SysMgrBiz.toSchoolPsychoTeacher",
          LYCom.GetToken(),
          {
            school_id: this.schoolForm.schoolId,
            isordinary: this.currentSchoolInfo.isordinary,
          }
        );
      });
    },
    uiLogin() {
      var self = this;
      if (self.isLogn) {
        return;
      }
      this.userName = this.userName.replace(/\s*/g, "");
      self.isLogn = true;
      if (this.userName.length < 23) {
        LYCom.AsynCallBiz(
          function (e) {
            if (e.err) {
              self.isLogn = false;
            } else {
              if (e.rtnObj) {
                var result = e.rtnObj;
                if (result.success) {
                  if (result.data != null) {
                    //设置token信息
                    self.$store.commit(
                      "SET_TOKEN",
                      result.data.TokenInfo.token_id
                    );
                    //  平台咨询师选择服务学校后进入平台
                    if (
                      result.data.UserInfo.role_group == 12 ||
                      result.data.UserInfo.is_platformConsultant ||
                      result.data.UserInfo.role_group == 14
                    ) {
                      self.selectSchoolDialog = true;
                    }
                    // 其他角色直接进入首页
                    else {
                    }
                    // self.toFullscreen();
                  }
                } else {
                }
              } else {
                self.isLogn = false;
              }
            }
          },
          "SysMgrBiz.Login",
          this.userName,
          this.userPwd,
          1 //  devType  终端类型（1：PC网页；2：平板端）
        );
      }
      // 2.0 token  兼容不到1.0 重新获取token
      this.$request
        .post("/educationadmin/userLogin", {
          username: this.userName,
          password: this.userPwd,
        })
        .then((res) => {
          if (res && res.userInfo) {
            let userInfo = res.userInfo;
            let nowDate = Number(new Date());
            let serviceExpireDate = nowDate;
            if (userInfo.serviceExpireTime) {
              serviceExpireDate = Number(new Date(userInfo.serviceExpireTime));
            }
            let remainingTime = serviceExpireDate - nowDate; // 服务剩余时间

            if (!userInfo.enable) {
              // 服务到期后被停用
              if (userInfo.serviceExpireTime && remainingTime < 0) {
                this.$alert(
                  "尊敬的使用者,您的账号因服务费已到期,请联系管理员续费后使用!",
                  "温馨提示!",
                  {
                    confirmButtonText: "确定",
                    // showConfirmButton:false,
                  }
                )
                  .then(() => { })
                  .catch(() => { });
              }
              // 系统停用账号
              else {
                return this.$message.error("当前账户已被停用,请联系管理员!");
              }
            } else {
              // 判断服务时间是否过期,做友情提示
              if (userInfo.serviceExpireTime && remainingTime < 0) {
                this.$alert(
                  "尊敬的使用者,您的账号服务费已到期,为避免影响正常使用,请尽快联系管理员续费!",
                  "温馨提示!",
                  {
                    confirmButtonText: "确定",
                    // showConfirmButton:false,
                  }
                )
                  .then(() => {
                    this.loginNext(res);
                  })
                  .catch(() => {
                    this.loginNext(res);
                  });
              } else {
                this.loginNext(res);
              }
            }
          } else {
            this.$message.err("用户信息获取错误!");
          }
        })
        .catch((err) => {
          this.isLogn = false;
          this.$message.error(err.msg);
        });
    },
    // 下一步
    loginNext(res) {
      if (res && res.token) {
        window.sessionStorage.setItem("LyToken", res.token);
        window.sessionStorage.setItem(
          "loginUserInfo",
          JSON.stringify(res.userInfo)
        );

        // 平台咨询师
        if (res.currentRoleGroup == 12|| res.currentRoleGroup==14) {
          this.getEduList(); // 获取教育局列表
        } else if (res.currentRoleGroup == 8) {
          this.$store.commit("eduWebConfig/updateStudentBasicInfoDialog", true);
          this.$router.push("/sysmgr/myTask");
        } else if (res.currentRoleGroup == 13) {
          this.$store.commit("eduWebConfig/updateStudentBasicInfoDialog", true);
          this.$router.push("/sysmgr/myTask1");
        }
        // 其他角色
        else {
          this.$router.push("/home");
        }
      }
    },
    toFullscreen() {
      //不支持screenfull全屏，则打印错误
      if (!screenfull.isEnabled) {
        console.error("unEnabled");
        return;
      }
      screenfull.toggle();
    },
    // 忘记密码
    backPwd() {
      this.$router.push({
        name: "forgetPassword",
      });
    },
    backApp() {
      this.$router.push({
        name: "appIntroduce",
      });
    },
  },
};
</script>

<style scoped>
.qhTitle {
  font-family: "\5FAE\8F6F\96C5\9ED1 Regular", "\5FAE\8F6F\96C5\9ED1";
  font-style: normal;
  color: #fff;
  line-height: 60px;
  font-size: 45px;
  margin-top: 205px;
  /* margin-top: 50px; */
  text-align: center;
}

.loginpage {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: #eef3fa;
  height: 100%;
  width: 100%;
  z-index: 1000;
}

.loginBox {
  position: absolute;
  left: 50%;
  min-width: 1658px;
  width: 100%;
  height: 100%;
  background: linear-gradient(090deg, #04185b, #19a4d1);
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  background-image: url("/static/images/login_bg.jpg");
  background-size: cover;
}

.topImg img {
  width: 100%;
  height: 100%;
}

.login-content {
  width: 1050px;
  height: 540px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  -webkit-border-radius: 5px;
  -ms-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(12, 82, 126, 1);
}

.login-left {
  float: left;
  width: 49%;
  height: 100%;
  background-image: url("/static/images/login_box_bg.jpg");
  border-radius: 5px 0 0 5px;
  /*padding: 10px;*/
}

.login-right {
  float: left;
  width: 44%;
  margin: 30px;
}

.title1 {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 48px;
  color: #ffffff;
  padding: 30px 30px 0 30px;
  /*text-align: left;*/
}

.title2 {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
  padding-left: 55px;
  line-height: 40px;
}

.group {
  font-family: "\5FAE\8F6F\96C5\9ED1 Regular", "\5FAE\8F6F\96C5\9ED1";
  font-weight: 400;
  font-style: normal;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  font-size: 35px;
  letter-spacing: 6px;
}

.title3 {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #01058a;
  font-size: 32px;
  padding: 25px 0 10px 10px;
}

.title4 {
  font-family: "微软雅黑 Bold", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #01058a;
}

.title5,
.forget_pwd {
  color: #918d9a;
  font-family: "Arial Normal", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  cursor: pointer;
}

.forget_pwd:hover {
  color: #01058a;
}

.log-row {
  padding: 10px 10px 10px 10px;
}

.log-row {
  width: 410px !important;
}


.row1 {
  padding: 10px 10px 10px 10px;
}

.row1 {
  width: 410px ;
}
.input-style {
  width: 410px;
  border: none;
  /*height: 50px;*/
}

.btn {
  /*margin-top: 24px;*/
  font-weight: 700;
  font-size: 18px;
  height: 48px;
}

.bottom-text {
  width: 100%;
  position: absolute;
  bottom: 1%;
  text-align: center;
  font-size: 14px;
}

.bottom-text a {
  color: #ffffff;
  text-decoration: none;
}

.el-input__inner {
  height: 48px;
  border: none;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0px;
}

 .el-radio__inner {
  width: 18px !important;
  height: 18px !important;
}

.schoolForm {
  padding: 20px 20px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue